/* eslint-disable @typescript-eslint/naming-convention */
import { useTranslation } from "react-i18next";

import {
  Log,
  RecaptchaEnterpriseActions,
  recaptchaEnterpriseSiteKey,
} from "@ryde/shared";

declare global {
  interface Window {
    grecaptcha?: {
      enterprise?: {
        execute: (
          siteKey: string,
          options: { action: string },
        ) => Promise<string>;
      };
    };
  }
}

interface IUseOtpErrors {
  getRecaptchaToken: (
    action: RecaptchaEnterpriseActions,
  ) => Promise<string | undefined>;
}

export const useRecaptchaToken = (): IUseOtpErrors => {
  const { t } = useTranslation();

  const getRecaptchaToken = async (
    action: RecaptchaEnterpriseActions,
  ): Promise<string | undefined> => {
    if (
      !action ||
      !Object.values(RecaptchaEnterpriseActions).includes(action)
    ) {
      Log.error("Invalid Recaptcha Action");
      return;
    }

    if (!window?.grecaptcha?.enterprise) {
      Log.error(t("errors.recaptchaNotLoaded"));
      return;
    }

    return window?.grecaptcha?.enterprise?.execute(
      recaptchaEnterpriseSiteKey(),
      { action },
    );
  };

  return { getRecaptchaToken };
};
